import { P as ProgressBar, d as defineCustomElement$1 } from './progress-bar.js';

const TtProgressBar = ProgressBar;
const defineCustomElement = defineCustomElement$1;

export { TtProgressBar, defineCustomElement };
